import styled from '@emotion/styled';
import { colors } from '@smartsheet/lodestar-core';

export const Divider = styled.div(`
	padding: 16px;
	background-color: ${colors.neutralLight10};
	box-sizing: initial;
	background-clip: content-box;
	height: 2px;
`);
